import { render, staticRenderFns } from "./AcoesGuias.vue?vue&type=template&id=56f82112"
import script from "./AcoesGuias.vue?vue&type=script&lang=js"
export * from "./AcoesGuias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports